module.exports = __webpack_public_path__ + "static/media/Edit-Line.1fdc13a7.svg";